import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseModule } from '@sb/library/base';
import { ButtonModule } from '@sb/library/button';
import { ChipButtonModule } from '@sb/library/chip-button';
import { EmptyStateModule } from '@sb/library/empty-state';
import { IconModule } from '@sb/library/icon';
import { LocalizationModule } from '@sb/library/localization';
import { ManagersModule } from '@sb/library/managers';
import { StatusLabelModule } from '@sb/library/status-label';
import { MbscDatepickerModule } from '@mobiscroll/angular';
import { SignUpSlotPickerComponent } from './sign-up-slot-picker/sign-up-slot-picker.component';
import { SlotPickerComponent } from './slot-picker.component';
import { TimegridPickerComponent } from './timegrid-picker/timegrid-picker.component';
import { FormFieldModule } from '@sb/library/form-field';

@NgModule({
    declarations: [
        SlotPickerComponent,
        SignUpSlotPickerComponent,
        TimegridPickerComponent
    ],
    imports: [
        CommonModule,
        IconModule,
        MbscDatepickerModule,
        FormsModule,
        ButtonModule,
        LocalizationModule,
        ChipButtonModule,
        StatusLabelModule,
        BaseModule,
        ManagersModule,
        EmptyStateModule,
        FormFieldModule
    ],
    exports: [
        SlotPickerComponent,
        SignUpSlotPickerComponent,
        TimegridPickerComponent
    ]
})
export class SlotPickerModule { }
